import front_es from './es/front.json';
import back_es from './es/back.json';

export const resources = {
  es: {
    allTranslations: { ...front_es, ...back_es }
  }
};
